import { render, staticRenderFns } from "./CpuSockets.vue?vue&type=template&id=6dc5de01&scoped=true&"
import script from "./CpuSockets.vue?vue&type=script&lang=js&"
export * from "./CpuSockets.vue?vue&type=script&lang=js&"
import style0 from "./CpuSockets.vue?vue&type=style&index=0&id=6dc5de01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5de01",
  null
  
)

export default component.exports